import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEN from './en.json';
import translationES from './es.json';
import translationPT from './pt.json';

const savedLanguage = localStorage.getItem('language') || 'pt';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: translationEN },
      pt: { translation: translationPT },
      es: { translation: translationES },
    },
    lng: savedLanguage,
    fallbackLng: 'pt',
    interpolation: { escapeValue: false },
  });

export default i18n;